import styled from 'styled-components';
import {
  white,
  IconChevronUp,
  TypeListItem,
  TypeList,
  cssSpacing,
} from '@spotify-internal/encore-web';
import { SectionWrapper } from '../Shared/components';

const iconSize = '24px';

export const FaqContainer = styled(SectionWrapper)`
  > article {
    padding: ${cssSpacing('looser-3')} 23px;
  }
`;

export const List = styled(TypeList)`
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const ListHeader = styled.div<{ textAlign: string }>`
  padding-bottom: ${cssSpacing('tighter-2')};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};
`;

export const ListItem = styled(TypeListItem)`
  border-bottom: 1px solid var(--background-tinted-highlight, ${white});
  &:last-child {
    border-bottom: unset;
  }
  padding-block-end: 0;
`;

export const ExpandIcon = styled(IconChevronUp)`
  vertical-align: middle;
  transform: rotate(180deg);
  width: ${iconSize};
  height: ${iconSize};
`;

export const QuestionTitleText = styled.div`
  display: inline-block;
  vertical-align: middle;
  padding-right: 10px;
  width: calc(100% - ${iconSize});
  box-sizing: border-box;
`;

export const QuestionTitle = styled.summary`
  cursor: pointer;
  padding: 28px 26px;
  margin-top: 2px;
  position: relative;
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
  outline: none;
  &:focus,
  &:hover {
    background-color: var(--background-elevated-highlight, #f0f0f0);
    & ${QuestionTitleText} {
      text-decoration: underline;
    }
  }
`;

export const QuestionContainer = styled.details`
  background-color: var(--background-elevated-base, #fff);
  color: var(--text-base, #000);
  &[open] ${ExpandIcon} {
    transform: rotate(0deg);
  }
`;

export const QuestionContent = styled.p`
  padding: 15px 32px 32px 32px;
  margin: 0;
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
